<template>
    <div class="events">
        <h1 class="events__title page-title">Search</h1>

        <el-tabs v-model="activeTab" readonly class="events__tabs" >
            <el-tab-pane label="Teams" name="teams" lazy>
                <search-teams />
            </el-tab-pane>
            <el-tab-pane label="Events" name="events" lazy>
                <search-events :all="true"/>
            </el-tab-pane>
            <el-tab-pane label="People" name="people" lazy>
                <search-people/>
            </el-tab-pane>
            <el-tab-pane label="AI" name="ai" lazy>
                <search-a-i/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import SearchEvents from '@/components/events/SearchEvents.vue';
import SearchTeams from '@/components/teams/SearchTeams.vue';
import SearchPeople from '@/components/people/SearchPeople.vue';
import SearchAI from '@/components/ai/SearchAI.vue';

export default {
    components: {
        SearchEvents,
        SearchTeams,
        SearchPeople,
        SearchAI
    },
    data() {
        return {
            activeTab: 'teams',
        };
    },
};
</script>

<style scoped>
.search-page {
    padding: 20px;
}
</style>